import { createElement, forwardRef } from 'react'

import { splitProps } from '../helpers.mjs';
import { getLevelRightStyle } from '../patterns/level-right.mjs';
import { styled } from './factory.mjs';

export const LevelRight = /* @__PURE__ */ forwardRef(function LevelRight(props, ref) {
  const [patternProps, restProps] = splitProps(props, [])

const styleProps = getLevelRightStyle(patternProps)
const mergedProps = { ref, ...styleProps, ...restProps }

return createElement(styled.div, mergedProps)
  })